<script>
	// Stores 
	import { textSite } from '../store.js';    

	// Componentes
	import { link } from "svelte-routing";
	import PageHeader from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Garantias Locatícias';    
	
	let itens = [{}];

	let garantias = [
		{
			name: 'Fiador',
			icon: `<i class="fas fa-user-shield"></i>`,
			text: `<p>A pessoa física que tenha certidão atualizada de dois registros de imóveis localizados no RS (não podendo possuir nenhum tipo de ônus). <b>Observação:</b> A renda a ser comprovada deverá ser superior a três vezes o valor do aluguel e encargos, podendo ser somada a renda do cônjuge.</p>`,
		},
		{
			name: 'Caução de Bem imóvel',
			icon: `<i class="fas fa-home"></i>`,
			text: `<p>A caução de bem imóvel consiste em alienar através de Escritura Pública um imóvel de propriedade do locatário ou de terceiro compatível com o valor da locação. O referido imóvel deverá estar registrado no Registro de Imóveis no Rio Grande do Sul e não possuir nenhum tipo de ônus ou impedimento legal.</p>
			<p>A documentação a ser apresentada pelo proprietário do imóvel é a seguinte:</p>
			<ul class="list-cycle">
				<li>Fotocópia do documento de identidade e CPF;</li>
				<li>Caso seja casado torna-se necessário encaminhar fotocópias da mesma documentação do cônjuge e também fotocópia da certidão de casamento;</li>
				<li>Fotocópia de comprovante de residência;</li>
				<li>Certidão atualizada do Registro de Imóveis, Certidão Negativa de Ônus Reais e Certidão Negativa de ações reais, pessoais reipersecutórias e Certidão Negativa Municipal.</li>
			</ul>`
		},
		{
			name: 'Seguro de fiança locatícia',
			icon: `<i class="fas fa-shield-alt"></i>`,
			text: `<p>É contratado através de uma seguradora, a qual garante a locação cobrando um valor calculado sobre o aluguel, encargos, multas e reparos. O valor cobrado pela seguradora deverá ser pago em uma única parcela, dependendo da aprovação cadastral. Esse seguro tem validade de 12 meses, devendo ser renovado e pago em caso de renovação do contrato. </p>
			<p>Salientamos que o valor do seguro não é restituído após a rescisão contratual.</p>
			<p>O futuro locatário necessita encaminhar os seguintes documentos juntamente com a ficha cadastral específica a ser preenchida:</p>
			<ul class="list-cycle">
				<li>Fotocópia do documento de identidade e CPF;</li>
				<li>Fotocópia dos três últimos comprovantes de renda e declaração do imposto de renda;</li>
				<li>Caso seja casado torna-se necessário encaminhar fotocópias da mesma documentação do cônjuge e também fotocópia da certidão de casamento;</li>
				<li>Fotocópia de comprovante de residência.</li>
				<li>Outros documentos poderão ser solicitados pela seguradora.</li>
			</ul>
			<p>Entre em contato para maiores informações.</p>`,
		},
		{
			name: 'Titulo de Capitalização',
			icon: `<i class="fas fa-money-check-alt"></i>`,
			text: `<p>É contratado através de uma seguradora. Essa modalidade de garantia necessita do pagamento de 18 vezes o valor do aluguel que fica caucionado durante o período da locação, e restituído após o final ao locatário.</p><p> Entre em contato para maiores informações.</p>`,
		},
		{
			name: 'Carta Fiança',
			icon: `<i class="fas fa-envelope"></i>`,
			text: `<p>Nosso departamento Jurídico está apto a analisar Cartas Fiança.</p>`,
		},
	];
</script>

<section class="conteudo-internas">
	<PageHeader title={titlePage}></PageHeader>
	<div class="container">
		<p>Formas de garantia ao contrato de Locação:</p>
		<div class="box-itens-icon">
			{#each garantias as garantia}
				<div class="item">
					<div class="icon maxw-200">
						{@html garantia.icon}
					</div>
					<div class="infos">
						<h2 class="title color-primary">{garantia.name}</h2>
						<p>{@html garantia.text}</p>
					</div>
				</div>
			{/each}
		</div>
		<br />
		<hr />
		<h2 class="title color-primary">Observações</h2>
		<ul class="list-cycle">
			<li>Os pretendentes a locação (locatários e fiadores) não podem ter restrições em empresas e/ou entidades de análise de crédito como “SPC e SERASA";</li>
			<li>O interessado somente terá preferência do imóvel após apresentar toda a documentação solicitada.</li>
			<li>Eventualmente poderão ser solicitados outros documentos para confirmação dos dados apresentados.</li>
		</ul>
		<br />
		<p>Em caso de dúvidas, entre em <a href="/contato" use:link>contato</a> conosco, nossa equipe está à disposição para auxiliar.</p>
		<div class="button text-center mt-40">
			<a href="/documentacao-necessaria" use:link replace title="Confira a documentação necessária para locação" class="btn btn-secondary">Confira a documentação necessária para locação <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> </a>
		</div>
	</div>
</section>